export enum NoteFilterShowOnDashboardTypes {
    all = 'all',
    onDashboard = 'on_dashboard',
    notOnDashboard = 'not_on_dashboard'
}